import { useContext } from "react";
import { RecordListContext, RecordListContextState } from "../components/RecordListProvider";
export const useRecordListContext = (): RecordListContextState => {
    const context = useContext(RecordListContext);

    if (!context) {
        throw new Error(
            "useRecordList must be used inside RecordListProvider"
        );
    }

    return context;
};
